import { PageHeader } from "@/components/DashboardLayout";
import BrokerDealsTable from "@/components/BrokerDealsTable";

export default function VendorProducts() {
    return (
        <>
            <PageHeader
                eyebrow="Portfolio"
                title="My products"
                description="The real, member-facing products Perx has linked to your vendor. View only — pricing and listing details are managed by Perx."
                testid="vendor-products-header"
            />

            <div className="px-6 lg:px-12 py-8">
                <BrokerDealsTable />
            </div>
        </>
    );
}
